export const CLOUD_FRONT_URL = "https://s3.amazonaws.com/box.import/";
export const PLAYER_LOAD_DELAY = 99;

export const LEGACY_API_ADDRESS = "http://sandbox.miltonjones.nl:1932/";

const SOCKET_URI =
  "wss://0wzd2p35c1.execute-api.us-east-1.amazonaws.com/production";

export let client = new WebSocket(SOCKET_URI);
